(window.OEAllArticles = function ($, Behaviors) {
    "use strict";

    const module = {};

    function OEAllArticles() {
        const holders = document.querySelectorAll('.bw-all-articles-wrapper');

        if (!holders.length) {
            return;
        }

        function loadFilteredPosts(page, terms, post_type, search, subheading_tag, title_tag, posts_per_page, holder) {
            holder.classList.add('loading');
            const xhr = new XMLHttpRequest();
            xhr.open('POST', wpAjaxUrl, true);
            xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
            xhr.onload = function () {
                if (xhr.status >= 200 && xhr.status < 400) {
                    const container = holder.querySelector('.bw-articles-holder-ajax');

                    container.innerHTML = xhr.responseText;
                    holder.classList.remove('loading');

                }
            };
            xhr.send(`action=filter_articles&paged=${page}&terms=${terms}&post_type=${post_type}&search=${search}&subheading_tag=${subheading_tag}&title_tag=${title_tag}&posts_per_page=${posts_per_page}`);
        }

        function get_active_terms(holder) {
            const active_terms = [];
            const terms = holder.querySelectorAll('.bw-filter');

            if(!terms.length) return '';

            terms.forEach(term => {
                if (term.classList.contains('active')) {
                    active_terms.push(term.dataset.filterTerm);
                }
            });

            if (active_terms.length > 0) {
                return active_terms.join(',');
            }

            return '';
        }

        function get_active_post_type(holder) {
            const post_type = holder.querySelector('.bw_post_type');

            if (post_type && post_type.value) {
                return post_type.value;
            }

            return '';
        }

        function get_search_query(holder) {
            const searchInput = holder.querySelector('.bw-article-search');

            if (searchInput && searchInput.value) {
                return searchInput.value;
            }

            return '';
        }

        function processFiltering(page, holder) {
            const active_terms = get_active_terms(holder);
            const active_post_type = get_active_post_type(holder);
            const search = get_search_query(holder);
            const subheading_tag =  holder.dataset.subheadingTag;
            const title_tag =  holder.dataset.titleTag;
            const posts_per_page =  holder.dataset.postsPerPage;

            loadFilteredPosts(page, active_terms, active_post_type, search, subheading_tag, title_tag, posts_per_page, holder);
        }


        holders.forEach(holder => {

            //PAGINATION
            holder.addEventListener('click', e => {
                const {target} = e;

                if (target.matches('.bw-pagination a')) {
                    e.preventDefault();
                    const link = target.getAttribute('href');

                    let page = link.replace(/.*page\/(\d+).*/, '$1');
                    if (page === link) {
                        page = link.replace(/.*paged=(\d+).*/, '$1');
                        if (page === link) {
                            page = '1';
                        }
                    }


                    processFiltering(page, holder);
                }
            });


            //Filters
            const filtersHolder = holder.querySelector('.filter-trigger__term');
            filtersHolder?.addEventListener('click', e => {
                const {target} = e;

                if (!target.matches('li.bw-filter')) {
                    return;
                }

                filtersHolder.querySelectorAll('li.bw-filter').forEach(filter => {
                    filter.classList.remove('active');
                });

                target.classList.add('active');
                if (target.dataset.filterPost !== undefined) {
                    holder.querySelector('.bw_post_type').value = target.dataset.filterPost;
                }

                processFiltering(1, holder);

            });

            //Search
            const searchInput = holder.querySelector('.bw-article-search');

            searchInput?.addEventListener('keyup', e => {
                if (e.key === 'Enter' && !holder.classList.contains('loading')) {
                    processFiltering(1, holder);
                }
            });

            const searchBtn = holder.querySelector('.bw-article-search-btn');

            searchBtn?.addEventListener('click', e => {
                processFiltering(1, holder);
            });
        });

    }

    document.addEventListener('DOMContentLoaded', function () {
        OEAllArticles();
    });

    return module;

}(window.jQuery, window.Behaviors));

